import { UpdateProjectPermissionInput, AppPermissionScope, AppModule, AppPermission } from '@bechtel/types';

export interface RolePermissionScope {
  id: UpdateProjectPermissionInput['id'];
  roleId: UpdateProjectPermissionInput['projectRoleId'];
  moduleId: AppModule['id'];
  moduleTypeId: UpdateProjectPermissionInput['moduleTypeId'];
  permissionId: UpdateProjectPermissionInput['permissionId'];
  permissionTypeId: AppPermission['permissionId'];
  scope: AppPermissionScope;
}

export enum CustomAuthScope {
  NONE = 'NONE',
  MULTIPLE = 'MULTIPLE',
}

export interface ModuleCollapsed {
  moduleId: string;
  collapsed: boolean;
}
